import { render, staticRenderFns } from "./TopEntityComponentDuration.vue?vue&type=template&id=9397f668&"
import script from "./TopEntityComponentDuration.vue?vue&type=script&lang=js&"
export * from "./TopEntityComponentDuration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports